<template>
  <img
    :src="require(`@/assets/img/${filename}`)"
    :alt="alt"
    :title="thetitle"
    :style="style"
    />
</template>

<script>
export default {
  name: 'logo-partner',
  props: {
    filename: {
      type: String,
      default: 'zerocoma.png'
    },
    alt: {
      type: String,
      default: 'partner'
    },
    title: {
      type: String,
      default: null
    },
    shadow: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      thetitle: this.title ? this.title : this.alt
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    style () {
      if (this.shadow) {
        return 'filter: drop-shadow(0 0 5px #0060C1);'
      }
      return ''
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.filter-black{
  filter: invert(100%) sepia(2%) saturate(6%) hue-rotate(335deg) brightness(104%) contrast(99%);
}
.filter-white{
  filter: invert(0%) sepia(2%) saturate(6%) hue-rotate(335deg) brightness(104%) contrast(99%);
}
.filter-main{
  filter: invert(70%) sepia(94%) saturate(776%) hue-rotate(168deg) brightness(98%) contrast(91%);
}
</style>
